import React from "react";
import MsalProviderWrapper from "components/msalProvider";
import ErrorBoundary from "components/common/ErrorBoundary";

export default function Providers({ children }) {
  return (
    <MsalProviderWrapper>
      <ErrorBoundary>{children}</ErrorBoundary>
    </MsalProviderWrapper>
  );
}
